module.exports = __webpack_public_path__ + "08_medium_brown.0728c357.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/08_medium_brown.png
// module id = z0ql
// module chunks = 0